import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from "../../../redux/Order/actions";
import Preloader from '../../layouts/Preloader';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import Breadcrumb from './Breadcrumb';
import { float2D } from '../../../utils/Validation';

function Content() {

    const dispatch = useDispatch();

    const [fetchSuccess, setFetchSuccess] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [exportStatement, setExportStatement] = useState([]);
    const [date, setDate] = useState("");

    const { StatementOfAccounts } = useSelector(state => state.OrderReducer);

    useEffect(() => {
        const Month = moment().format('DD-MM-YYYY');
        setDate(moment().format('YYYY-MM'));
        dispatch({
            type: actions.GET_ADMIN_STATEMENTOFACCOUNTS,
            payload: { Month: Month.slice(3, 5), Year: Month.slice(6, 10) }
        });
        // eslint-disable-next-line
    }, []);

    //validate the list is empty or not
    useEffect(() => {
        if (StatementOfAccounts.length !== 0) {
            if (StatementOfAccounts.result.length === 0) {
                setFilteredData([]);
            } else {
                setFilteredData(StatementOfAccounts.result)
            };
        };
    }, [StatementOfAccounts]);

    const handleTableSearch = (e) => {
        setDate(moment(e.target.value).format('YYYY-MM'));
        dispatch({
            type: actions.GET_ADMIN_STATEMENTOFACCOUNTS,
            payload: { Month: e.target.value.slice(5, 7), Year: e.target.value.slice(0, 4) }
        });
    };

    const handlePageRefresh = (e) => {
        e.preventDefault();
        const Month = moment().format('DD-MM-YYYY');
        setDate(moment().format('YYYY-MM'))
        dispatch({
            type: actions.GET_ADMIN_STATEMENTOFACCOUNTS,
            payload: { Month: Month.slice(3, 5), Year: Month.slice(6, 10) }
        });
    };

    const handleExport = () => {
        const Statement = [
            [
                "Date",
                "Order ID",
                "Payment Type",
                "Sales Amount",
                "Coupon Amount",
                "Received Amount",
                "Pending Amount",
            ],
            [
                " ", " ", " ", " ", " ", "Opening Balance:", float2D(StatementOfAccounts?.OpeningBalance)
            ],
            [
                " ", " ", " ", " ", "", " ", " "
            ],
            ...filteredData?.map(order =>

                order.Status === 'Cancelled' ?
                    [
                        order.Status_Updated_On ? order.Status_Updated_On : order.Created_On,
                        order.Id,
                        "-",
                        "Cancelled",
                        "-",
                        "-",
                        "-"
                    ] :
                    [
                        order.Status_Updated_On ? order.Status_Updated_On : order.Created_On,
                        order.Id,
                        order.PaymentType,
                        float2D(parseFloat(order.Total) + parseFloat(order.CouponValue || 0)),
                        float2D(order.CouponValue || 0),
                        order.PaymentStatus === 'Paid' ? (float2D(order.Total))?.toString() : '-',
                        order.PaymentStatus === 'Paid' ? '0.00' : float2D(order.Total)
                    ]
            ),
            [
                " ", " ", " ", " ", "", " ", " "
            ],
            [
                " ", " ", " ", " ", " ", "Pending Payment:", float2D(StatementOfAccounts?.ClosingBalance)
            ],
        ]
        Statement.reduce((prev, curr) => [prev, curr]);
        const data = Statement;
        setExportStatement(data);
    };

    //loading
    useEffect(() => {
        (StatementOfAccounts.length === 0) ? setFetchSuccess(false) : setFetchSuccess(true);
    }, [StatementOfAccounts]);

    return (
        <>
            {!fetchSuccess ?
                <Preloader fetchSuccess={fetchSuccess} /> :
                <div className="ms-content-wrapper">
                    <div className="row">
                        <div className="col-md-12">
                            <Breadcrumb handlePageRefresh={handlePageRefresh} />
                            <div className="ms-panel">
                                <div className="ms-panel-body tabledata-background">
                                    <h6 className='text-uppercase font-weight-bold'>Statement Of Accounts</h6>
                                    <span className="float-right add-banner-button">
                                        {filteredData?.length === 0 ?
                                            <button className="btn btn-success add-button rounded text-white font-weight-bold" disabled type="submit"> EXPORT</button> :
                                            <button className="btn btn-success add-button rounded" type="submit">
                                                <CSVLink
                                                    data={exportStatement}
                                                    filename={`Statement of ${date?.slice(5, 7)} - ${date?.slice(0, 4)}.csv`}
                                                    className="text-white font-weight-bold"
                                                    target="_blank"
                                                    onClick={handleExport}
                                                >
                                                    EXPORT
                                                </CSVLink>
                                            </button>
                                        }
                                    </span>
                                </div>
                                <div className='header-break-line'> <hr /> </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row ">
                                                <div className="col-sm-12 col-md-6"></div>
                                                <div className="col-sm-12 col-md-6 mb-2">
                                                    <div id="data-table-4_filter" className="dataTables_filter">
                                                        <label className="font-weight-bold">Select Month :
                                                            <input
                                                                type='month'
                                                                max={moment().format('YYYY-MM')}
                                                                className="form-control form-control-sm"
                                                                value={date || ''}
                                                                aria-controls="data-table-4"
                                                                onChange={handleTableSearch}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table id="data-table-5" className="table w-100 thead-primary dataTable no-footer" role="grid" aria-describedby="data-table-5_info" >
                                                        <thead>
                                                            <tr role="row">
                                                                <th scope="col">Date</th>
                                                                <th scope="col">Order ID</th>
                                                                <th scope="col">Payment Type</th>
                                                                <th scope="col">Sales Amount</th>
                                                                <th scope="col">Coupon Amount</th>
                                                                <th scope="col">Received Amount</th>
                                                                <th scope="col">Pending Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="odd sales-alignment">
                                                                <th className='id-column' scope="row"></th>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className='font-weight-bold'>Opening Balance</td>
                                                                <td className='font-weight-bold sales-alignment'>{float2D(StatementOfAccounts?.OpeningBalance)}</td>
                                                            </tr>
                                                            {filteredData.length > 0 ?
                                                                <>
                                                                    {filteredData.map((order) =>
                                                                        <> {order.Status === 'Cancelled' ?
                                                                            <tr className="odd" >
                                                                                <th className='id-column' scope="row">{order.Status_Updated_On ? order.Status_Updated_On.slice(0, 10) : order.Created_On.slice(0, 10)}</th>
                                                                                <td>{order.Id}</td>
                                                                                <td>----</td>
                                                                                <td className='font-weight-bold sales-alignment'>Cancelled</td>
                                                                                <td className='sales-alignment'>----</td>
                                                                                <td className='sales-alignment'>----</td>
                                                                                <td className='sales-alignment'>----</td>
                                                                            </tr> :
                                                                            <tr className="odd">
                                                                                <th className='id-column' scope="row">{order.Created_On ? order.Created_On.slice(0, 10) : order.Status_Updated_On.slice(0, 10)}</th>
                                                                                <td>{order.Id}</td>
                                                                                <td>{order.PaymentType}</td>
                                                                                <td className='sales-alignment'>{float2D(parseFloat(order.Total) + parseFloat(order.CouponValue || 0))}</td>
                                                                                <td className='sales-alignment'>{float2D(order.CouponValue)}</td>
                                                                                <td className='sales-alignment'>{order.PaymentStatus === 'Paid' ? float2D(order.Total) : '----'}</td>
                                                                                <td className='sales-alignment'>{order.PaymentStatus === 'Paid' ? '0.00' : float2D(order.Total)}</td>
                                                                            </tr>
                                                                        }
                                                                        </>
                                                                    )}
                                                                </> :
                                                                <tr>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                    <td>----</td>
                                                                </tr>
                                                            }
                                                            <tr className="odd sales-alignment">
                                                                <th className='id-column' scope="row"></th>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className='font-weight-bold'>Total Pending Amount</td>
                                                                <td className='font-weight-bold sales-alignment'>{float2D(StatementOfAccounts?.ClosingBalance)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default Content;